import ConfigurationItemBaseViewModel from "./configuration-item-base";
import BaoDialog from "./../factories/bao-dialog";
import Bao from "./../services/bao-service";
import * as ko from "knockout";
import TabPage from "../factories/tab-page";

class QuestionViewModel extends ConfigurationItemBaseViewModel {
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.AuditTrailKeyPermission("QuestionAuditTrail");
    }

    /**
     * Id of the Question Type
     */
    public QuestionTypeId: KnockoutObservable<string> = ko.observable();

    /**
     * Id of the Question Type
     */
    public QuestionTypeName: KnockoutObservable<string> = ko.observable();

    /**
     * Text of the Question displayed in the Frontend
     */
    public QuestionText: KnockoutObservable<string> = ko.observable();

    /**
     * Descirption of the Question
     */
    public Description: KnockoutObservable<string> = ko.observable();

    /**
     * Represents the Order of the Questions in the Frontend
     */
    public SortNumber: KnockoutObservable<number> = ko.observable();

    /**
     * The json contains the definition/template of the question type.
     */
    public JSON: KnockoutObservable<string> = ko.observable();

    /**
     * Bao Searcher for selecting the ConfigurationItemStatus
     */
    public QuestionTypeSearcher: Bindings.baoSearcher = {
        SearchType: "QuestionType",
        ObjectId: this.QuestionTypeId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true,
    };

    /**
     * The init url for the backend.
     */
    public InitUrl(): string {
        return "Question/Init";
    }

    /**
     * Calls the init() function from base class.
     */
    public init(): JQueryPromise<void> {
        return super.init()
    }

    /**
     * Checks if all mandatory fields are filled and prevents from saving if so.
     * @returns True if all mandatory fields are filled.
     */
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        let completed: boolean = true;
        if (!this.QuestionText() || !this.ConfigurationItemStatusId() ||
            !this.ConfigurationItemTypeId() || !this.QuestionTypeId()) {
            completed = false;
        }
        if (!completed) {
            let baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
}
export default QuestionViewModel;